var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-board-container"},[_c('BoardFilters'),_c('BoardView',{attrs:{"board-type":"jobs"},on:{"job-selected":_vm.onJobSelected,"job-moved":_vm.onJobMoved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }